import { createContext } from "react";

export interface ActivityObserverContextProps {
  triggerActivity: () => false;
  throttledTriggerActivity: () => void;
}

export const ActivityObserverContext =
  createContext<ActivityObserverContextProps>({
    triggerActivity: () => false,
    throttledTriggerActivity: () => false,
  });
